const MoengageEvents = {
  CheckoutPageAction: "CheckoutPageAction",
  OrderAPIStatus: "OrderAPIStatus",
  OrderPageAction: "OrderPageAction",
  LandingPageLoaded:"LandingPageLoaded",
  LandingPageAction:"LandingPageAction",
  MenuSectionAction:"MenuSectionAction",
  LoginPageLoaded:"LoginPageLoaded",
  LoginPageAction:"LoginPageAction",
  TimeSpent:"TimeSpent",
  VerticalScroll:"VerticalScroll",
  BusinessContentCreated:"BusinessContentCreated"
};
export default MoengageEvents;
